module.exports = __webpack_public_path__ + "img/luna-pink.f12d340a.png";